import useGhaiPopWeekdayAvgLateNight, {
  ghaiPopWeekdayAvgLateNightConfigs,
} from './useGhaiPopWeekdayAvgLateNight'

export const configs = {
  ghaiPopWeekdayAvgLateNight: ghaiPopWeekdayAvgLateNightConfigs,
}

export const api = {
  ghaiPopWeekdayAvgLateNight: useGhaiPopWeekdayAvgLateNight,
}
